import {all, fork} from "redux-saga/effects";
import handleSelectedLocation from "./handleLocationInteractions";
import handleScore from "./handleScore";
import handleGameEvents from "./handleGameEvents";
import handleHints from "./handleHints";
import handleOutages from "./handleOutages";
import handleEvents from "./handleEvents";
import handleCalendar from "./handleCalendar";


/**
 * watch for relevant actions
 */
export default function* rootSaga()
{
    yield all([
        fork(handleSelectedLocation),
        fork(handleEvents),
        fork(handleGameEvents),
        fork(handleScore),
        fork(handleHints),
        fork(handleOutages),
        fork(handleEvents),
        fork(handleCalendar),
    ]);
}



// WEBPACK FOOTER //
// ./src/ts/store/sagas/rootSagas.ts